import { render, staticRenderFns } from "./DebugInfo.vue?vue&type=template&id=50fd1d85"
import script from "./DebugInfo.vue?vue&type=script&lang=js"
export * from "./DebugInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports